import React from "react";
function Footer(){
    return(
        <div className="relative left-0 bottom-0 ">
        <footer className="flex h-[6rem] justify-center items-center bg-[#a80202]">
    <span className="text-2xl text-white">TCE Events | © Department of CSE, TCE
    </span>
</footer>
</div>
    )
}
export default Footer;